import { locales } from '@/i18n';

export const languageList = [
  { text: 'English', value: locales.en, icon: 'icon-english' },
  { text: 'Svenska', value: locales.sv, icon: 'icon-swedish' },
];

export const RANKED_APARTMENTS_COUNT = 20;

export const BLOG_MAX_COUNT = 8;
